import { Theme } from "./Theme";

export const darkTheme: Theme = {
  colors: {
    neutral: {
      background: "#000000",
      text: "#f5f5f7",
      border: "#383838",
      secondaryText: "#eaeaea",
      imageFallbackBackground: "#cccccc",
      buttonBackground: "#cccccc",
      dropdownSelected: "#0062ff",
      tabColor: "#eaeaea",
      selectedTabColor: "#f5f5f7",
    },
  },
};
